<script setup>
import { defineProps, defineEmits } from 'vue'
import { useIcon } from '@/hooks/useIcon'
import { colorRgb } from '@/components/schoolInstrument/mixins/utils.js'
import { MY_CONSTANTS } from '@/util/constants'
const props = defineProps({
  menuInfo: {
    type: Object,
    default: () => ({}),
  },
  menuLayoutList: {
    type: Array,
    default: () => ([]),
  },
  activeMenuItem: {
    type: Number,
    default: 0,
  },
  activeMenu: {
    type: Number,
    default: 0,
  },
  activeTopMenu: {
    type: Number,
    default: 0,
  },
  themeColor: {
    type: String,
    default: '#409eff',
  },
  menuHeight: {
    type: Number,
    default: 0,
  }
})

const emit = defineEmits(['handleMenuClick'])

const { isObject, IconModule } = useIcon()

const handleBgInfo = (bgInfo)=> {
  let background = null
  if (bgInfo) {
    const { radio } = bgInfo
    if (radio === 'imgurl') {
      const backgroundImage = `url(${MY_CONSTANTS.$imgurl + bgInfo[radio]})`
      return {
        backgroundImage
      }
    } else {
      background = bgInfo.color
    }
  } else {
    background = '#fff'
  }
  return {
    background
  }
}

const getCustomImg = (column) => {
  if (column.autonomyIcon) {
    return MY_CONSTANTS.$imgurl + column.autonomyIcon
  } else if (typeof column.iconName === 'string') {
    return MY_CONSTANTS.$imgurl + column.iconName
  } else {
    return `https://bigdata.topeti.com/PCRepository/middleground/home/icon/group/group-${column.iconName}.svg`
  }
}

const isAppenMask = (item) => {
  const list = item.apply
  let flag = false
  if (list) {
    const idx = list.findIndex(c => c.id === props.activeMenuItem)
    if (idx !== -1) {
      flag = true
    }
  }
  return flag
}

const handleMenuClick = (item, citem) => {
  emit('handleMenuClick', item, citem)
}
</script> 

<template>
  <div class="left-menu-nav" :style="{ '--themeColor': themeColor }">
    <template v-if="menuInfo.imgOpen === 'open'">
      <div class="navbar-default-top-img" ref="webdesignMenuImg">
        <img v-if="menuInfo.imgUrl" :src="$imgurl + menuInfo.imgUrl" />
      </div>
      <div class="navbar-default-mid"><div :style="handleBgInfo(menuInfo.bgInfo)"></div></div>
    </template>
    <el-menu
      :style="{
        paddingTop: menuInfo.imgOpen === 'close' ? '16px' : '',
      }"
      :active-text-color="themeColor"
      :default-active="activeMenuItem + ''"
      unique-opened
      :key="activeTopMenu"
      :class="menuInfo.style === 'icon' ? 'navbar-default-icon' : 'navbar-default-tree'"
    >
      <el-scrollbar :style="{ height: menuHeight ? menuHeight + 'px' : '800px' }">
        <template v-for="(column, index) in menuLayoutList">
          <el-sub-menu
            :key="index"
            v-if="column.apply && (column.isAppenCol || column.isAppenCol === undefined)"
            :index="column.id + ''"
          >
            <template #title>
              <div>
                <div class="column-item-img">
                  <icon-module v-if="isObject(column.iconName)" :config="isAppenMask(column) ? (column.highIconName || column.iconName) : column.iconName"></icon-module>
                  <template v-else>
                    <img v-if="column.autonomyIcon || column.iconName" :src="getCustomImg(column)" />
                  </template>
                </div>
                <div class="title-marsk" :style="{ background: column.bgColor }"></div>
                <span class="title" :style="column.fontStyle" :title="column.name">{{ column.name }}</span>
              </div>
            </template>
            <el-menu-item-group>
              <template v-for="(apply, i) in column.apply">
                <el-menu-item
                  :key="i"
                  v-if="apply.isAppenCol || apply.isAppenCol === undefined"
                  :index="apply.id + ''"
                  @click="handleMenuClick(column, apply)"
                >
                  <div class="marsk" :style="{ background: colorRgb(themeColor, 0.1) }" />
                  <span class="left-navbar"></span>
                  <div class="icon">
                    <icon-module v-if="isObject(apply.iconName)" :config="activeMenuItem === apply.id ? (apply.highIconName || apply.iconName) : apply.iconName"/>
                    <template v-else>
                      <img v-if="apply.autonomyIcon || apply.iconName" :src="getCustomImg(apply)" />
                    </template>
                  </div>
                  <span class="title" :style="apply.fontStyle" :title="apply.name">{{ apply.name }}</span>
                </el-menu-item>
              </template>
            </el-menu-item-group>
          </el-sub-menu>
          <template v-else>
            <el-menu-item
              :key="index"
              class="apply-menu"
              :index="column.id + ''"
              v-if="column.isAppenCol || column.isAppenCol === undefined"
              @click="handleMenuClick(column)"
            >
              <div class="column-item-img">
                <icon-module v-if="isObject(column.iconName)" :config="activeMenuItem === column.id ? (column.highIconName || column.iconName) : column.iconName" />
                <template v-else>
                  <img v-if="column.autonomyIcon || column.iconName" :src="getCustomImg(column)" />
                </template>
              </div>
              <div class="marsk" :style="{ background: colorRgb(themeColor, 0.1) }" />
              <span class="left-navbar"></span>
              <span class="title" :style="column.fontStyle" :title="column.name">
                {{ column.name }}
              </span>
            </el-menu-item>
          </template>
        </template>
      </el-scrollbar>
    </el-menu>
  </div>
</template>

<style scoped lang='scss'>
@import '../mixins/style.scss';
$themeColor: var(--themeColor);
::v-deep .navbar-default-icon {
  width: 100%;
  border-right: none;
  .el-menu-item:hover,
  .el-menu-item:focus {
    background: rgba($color: $themeColor, $alpha: 0.1) !important;
  }
  .is-active.apply-menu{
    .marsk {
      display: inline-block !important;
    }
    .title {
      color: $themeColor !important;
    }
    .left-navbar{
      display: block !important;
    }
  }
  .apply-menu {
    line-height: 40px;
    height: 40px;
    .column-item-img {
      img {
        max-width: 24px;
        max-height: 24px;
        top: 50%;
        transform: translateY(-50%);
        position: absolute;
      }
    }
    .marsk {
      display: none;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 0;
      width: 100%;
      height: 100%;
    }
    .left-navbar {
      display: none;
      border-radius: 0 5px 5px 0;
      height: 40px;
      width: 4px;
      background: $themeColor;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    .title {
      font-family: "PingFang SC";
      margin-left: 30px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      position: relative;
      z-index: 2;
    }
  }
  .el-sub-menu__title {
    display: flex;
    height: 40px;
    line-height: 40px;
    position: relative;
    &:hover {
      background: none;
    }
    .el-submenu__icon-arrow {
      color: #33393e;
    }
    .column-item-img {
      img {
        max-width: 24px;
        max-height: 24px;
        top: 50%;
        transform: translateY(-50%);
        position: absolute;
      }
    }
    .title {
      font-family: "PingFang SC";
      margin-left: 30px;
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      position: relative;
      z-index: 2;
    }
  }
  .el-menu-item-group {
    .is-active {
      .title {
        font-weight: 500;
        color: $themeColor !important;
      }
    }
    .el-sub-menu {
      .el-sub-menu__title {
        height: 36px;
        line-height: 36px;
      }
      .el-menu-item-group__title {
        padding: 0;
      }
      .is-active {
        .marsk {
          display: block !important;
        }
        .left-navbar {
          display: block !important;
        }
      }
      .el-menu-item {
        display: flex;
        position: relative;
        line-height: 36px;
        height: 36px;
        margin-bottom: 10px;
        &:hover,
        &:focus {
          background: none;
        }
        &:focus {
          background-color: none;
        }
      }
    }
  }
  .el-sub-menu {
    .el-sub-menu__title {
      height: 40px;
      line-height: 40px;
      z-index: 1;
    }
    .el-menu-item-group__title {
      padding: 0;
    }
    .is-active {
      .marsk {
        display: block !important;
      }
      .left-navbar {
        display: block !important;
      }
    }
    .el-menu-item {
      display: flex;
      position: relative;
      height: 40px;
      line-height: 40px;
      margin-bottom: 10px;
      &:hover,
      &:focus {
        background: none;
      }
      .apply-item-img {
        img {
          width: 24px;
          max-height: 24px;
          position: absolute;
          top: 50%;
          left: 18%;
          transform: translateY(-50%);
        }
      }
      .marsk {
        display: none;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0;
        width: 100%;
        height: 100%;
      }
      .left-navbar {
        display: none;
        border-radius: 0 5px 5px 0;
        height: 40px;
        width: 4px;
        background: $themeColor;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      .icon {
        img {
          max-width: 24px;
          max-height: 24px;
          position: absolute;
          top: 50%;
          left: 20px;
          transform: translateY(-50%);
        }
      }
      .title {
        margin-left: 9px;
        font-weight: 400;
        font-family: "PingFang SC";
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        position: relative;
        z-index: 2;
      }
    }
  }
}

.navbar-default-top-img {
  margin-top: 16px;
  height: auto;
  width: 100%;
  padding: 0 8px;
  box-sizing: border-box;

  img {
    width: 100%;
    height: 100%;
  }
}

.navbar-default-mid {
  width: 100%;
  box-sizing: border-box;
  height: 1px;
  display: flex;
  justify-content: center;
  margin: 16px 0;

  div {
    width: 92%;
    box-sizing: border-box;
    height: 1px;
    background: #eeeeee;
  }
}

::v-deep .navbar-default-tree {
    width: 99%;
    border-right: none;
    .el-menu-item:hover,
    .el-menu-item:focus {
      background: rgba( $color: $themeColor, $alpha: 0.1) !important;
    }
    .marsk {
      @include mask;
      display: none;
    }
    .is-active.el-menu-item{
      .marsk {
        display: inline-block !important;
      }
      .title {
        color: $themeColor !important;
      }
      .left-navbar{
        display: block !important;
      }
    }
    .apply-menu {
      @include line-center(54px);
      font-size: 16px;
      padding: 0 15px 0 32px !important;
      .column-item-img {
        img {
          width: 24px;
          max-height: 24px;
          top: 50%;
          transform: translateY(-50%);
          position: absolute;
        }
      }
      .title {
        margin-left: 42px;
        position: relative;
        z-index: 2;
        @include ellipsis;
      }
    }
    .el-sub-menu__title {
      display: flex;
      @include line-center(54px);
      position: relative;
      padding: 0 15px 0 32px !important;
      z-index: 1;
      &:hover {
        background: none;
      }
      .column-item-img {
        img {
          width: 24px;
          max-height: 24px;
          top: 50%;
          transform: translateY(-50%);
          position: absolute;
        }
      }
      .title {
        margin-left: 42px;
        position: relative;
        z-index: 2;
        @include ellipsis;
      }
    }
    .el-menu-item-group {
      margin: 0 15px;
      box-sizing: border-box;
      margin-top: 5px;
      border-radius: 8px;
      .is-active {
        .title {
          color: $themeColor !important;
        }
      }
      .el-sub-menu {
        .el-sub-menu__title {
          @include line-center(54px);
        }
        .el-menu-item-group__title {
          padding: 0;
        }
        .el-menu-item {
          display: flex;
          position: relative;
          @include line-center(54px);
          &:hover,
          &:focus {
            background: none;
          }
          &:focus {
            background-color: none;
          }
        }
      }
    }
    .el-sub-menu {
      .el-sub-menu__title {
        @include line-center(54px);
        font-size: 16px;
      }
      .el-menu-item-group__title {
        padding: 0;
      }
      .el-menu-item {
        display: flex;
        position: relative;
        @include line-center(54px);
        padding: 0 16px !important;
        &:hover,
        &:focus {
          background: none;
        }
        .apply-item-img {
          img {
            width: 24px;
            max-height: 24px;
            position: absolute;
            top: 50%;
            left: 18%;
            transform: translateY(-50%);
          }
        }
        .icon {
          img {
            width: 24px;
            max-height: 24px;
            position: absolute;
            top: 50%;
            left: 18px;
            transform: translateY(-50%);
          }
        }
        .title {
          margin-left: 44px;
          @include ellipsis;
          position: relative;
          z-index: 2;
        }
      }
    }
}
</style>
